import { makeAddressSync } from "@silo/types";

/**
 * This is a test token used for initial merkl integration and should be ignored.
 */
export const AGLA_MERKL_ADDRESS = makeAddressSync(
  "0xE0688A2FE90d0f93F17f273235031062a210d691"
);

export const SUPERFEST_TAG = "superfest";
